module.exports = __webpack_public_path__ + "static/media/laos-flag.8eede962.png";